<section>
    <div class="info">
        <div class="info-icon">
            <xm-media-image aria-hidden="true" [imageOptions]="displayImage" size="auto"></xm-media-image>
        </div>
        <div class="addon">
            <h4 *ngIf="subtitle" class="plan-name">{{ subtitle }}</h4>
            <span>{{ title }}</span>
            <span>{{ price }}</span>

            <p class="plan-subheader">
                {{ subheader }}
            </p>
        </div>
        <div *ngIf="showBadge" class="action-icon">
            <div class="icon-wrapper" [ngClass]="{'pending-removal': addon.status === 'PENDING_REMOVAL'}" role="status" [attr.aria-label]="subtitle + ' is ' + statusBadge">
                <xm-media-image [imageOptions]="inUseIcon" class="use-icon"></xm-media-image>
                <span class="action-text">{{ statusBadge }}</span>
            </div>
        </div>
        <div *ngIf="showBadgeWithoutIcon" class="action-icon">
            <div class="icon-wrapper" role="status" [attr.aria-label]="subtitle + ' is ' + statusBadge">
                <span class="action-text-without-icon">{{ statusBadge }}</span>
            </div>
        </div>
        <ng-container *ngIf="addon.type === 'INTERNATIONAL'; else notInternational">
            <a *ngIf="ctaLabel && ctaDestination && isCBMInternationalReteLinkEnabled" class="xm-btn-link-light intl-cta" [href]="ctaDestination" target="_blank" rel="noopener">{{ ctaLabel }}</a>
        </ng-container>
        <ng-template #notInternational>
            <div class="action" *ngIf="addon.status === 'PENDING_REMOVAL'">
                <button *ngIf="ctaLabel" class="xm-btn-secondary-light"
                    (click)="cancelRemovalFlow()">{{ ctaLabel }} <span class="accessibility-hidden">for {{ cmsAddonData.title }}</span>
                </button>
            </div>
            <div class="action" *ngIf="addon.status !== 'PENDING_REMOVAL'">
                <button *ngIf="ctaLabel" class="xm-btn-secondary-light"
                    (click)="addOnFlow()">{{ ctaLabel }} <span class="accessibility-hidden">for {{ cmsAddonData.title }}</span>
                </button>
            </div>
        </ng-template>
    </div>
</section>
